
const explanationWaitingTime = 1
const selectionWaitingTime = 1

export {
    explanationWaitingTime,
    selectionWaitingTime
}
